import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs } from 'components';
import * as styles from './PageHeader.scss';
import { connect } from 'react-redux';
var PageHeader = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PageHeader, _Component);

  var _super = _createSuper(PageHeader);

  function PageHeader() {
    _classCallCheck(this, PageHeader);

    return _super.apply(this, arguments);
  }

  _createClass(PageHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          primary = _this$props.primary,
          secondary = _this$props.secondary,
          theme = _this$props.theme,
          style = _this$props.style,
          pageTitleStyle = _this$props.pageTitleStyle;

      var inlineStyles = _objectSpread(_objectSpread({}, style), {}, {
        color: theme.colors.primaryColor
      });

      var crumbs = [this.props.organization.name];

      if (location.pathname.includes('settings')) {
        crumbs.push('Settings');
      }

      if (location.pathname.includes('publishing')) {
        crumbs.push('Publishing');
      }

      crumbs.push(primary, secondary);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.header,
        style: inlineStyles
      }, this.props.showCrumbs && !location.pathname.includes('global') && !location.pathname.includes('client-detail') && !location.pathname.includes('user') && !location.pathname.includes('compose') && !location.pathname.includes('create-ad') && !location.pathname.includes('users/') && !location.pathname.includes('draft-approval') && /*#__PURE__*/React.createElement(Breadcrumbs, {
        crumbs: crumbs
      }), /*#__PURE__*/React.createElement("h1", {
        className: styles.pageTitle,
        style: pageTitleStyle
      }, primary, secondary && /*#__PURE__*/React.createElement("span", {
        className: styles.secondary
      }, secondary)));
    }
  }]);

  return PageHeader;
}(Component), _defineProperty(_class2, "propTypes", {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  theme: PropTypes.object.isRequired,
  style: PropTypes.object
}), _defineProperty(_class2, "defaultProps", {
  secondary: '',
  pageTitleStyle: {},
  style: {},
  theme: {
    colors: {}
  },
  showCrumbs: true
}), _temp)) || _class);
export default PageHeader;